/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Modal, { ModalHeader } from '../Modal';
import Form from '../Form';
import useForm from '../../hooks/useForm';
import systemAlert from '../../utils/systemAlert';
import { toast } from '../../utils/toast';
import { addGroups, editGroup, deleteGroups } from '../../apis/companies/account';
import { isEmpty } from '../../utils/lodashExtend';

const defaultForm = {
  name: ""
};
const ClientGroup = (props) => {
  const { selectedItem, setSelectedItem, open, setOpen, submit } = props;
  const [fields] = useState([
    {
      title: "그룹명",
      key: "name",
      type: "input",
      required: true,
    },
  ]);
  const [mode, setMode] = useState('create');

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    if (setSelectedItem) {
      setSelectedItem(null);
    }
  };


  useEffect(() => {
    setValidateFields(fields);
    setMode(selectedItem ? 'detail' : 'create');
    if (selectedItem) {
      setForm(selectedItem);
      setOriginForm(selectedItem);
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
    }
  }, [open, selectedItem]);

  const _submit = (form) => {
    if (mode === "detail") {
      systemAlert(`"거래처 그룹을 수정하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '수정',
            onClick: () => {
              const data = {
                name: form.name
              };
              editGroup(selectedItem.idx, data)
                .then(() => {
                  toast.success("거래처 그룹이 수정되었습니다.");
                  cancel();
                  submit && submit();
                });
            }
          }
        ]
      });
    }
    else if (mode === "create") {
      systemAlert(`거래처 그룹을 등록하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '등록',
            onClick: () => {
              addGroups(form)
                .then(() => {
                  toast.success("거래처 그룹이 등록되었습니다.");
                  cancel();
                  submit && submit();
                });
            }
          }
        ]
      });
    }
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    setOriginForm,
    setValidateFields,
  } = useForm(
    defaultForm,
    _submit,
  );

  const deleteButtons = [
    {
      label: "닫기",
      color: "text",
      onClick: () => cancel(),
    },
    {
      isHide: isEmpty(selectedItem),
      label: "삭제",
      color: "red",
      onClick: () => {
        systemAlert(`거래처 그룹 [${selectedItem.name}]을(를) 정말 삭제하시겠습니까?\n 삭제하시면 거래처에 설정된 그룹이 모두 삭제됩니다.`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '삭제',
              color: 'red',
              onClick: () => {
                deleteGroups({ idx: [selectedItem.idx] })
                  .then(() => {
                    toast.success("삭제가 완료되었습니다.");
                    cancel();
                    submit && submit();
                  });
              }
            }
          ]
        });
      },
    },
    {
      label: mode === "create" ? "신규 등록" : "정보 수정",
      onClick: () => _submit(form)
    },
  ];


  return (
    <Modal
      isOpen={open}
      close={cancel}
    >
      <div className="item-write">
        <ModalHeader>
          거래처 그룹 {mode === "create" ? "신규 등록" : "수정"}
        </ModalHeader>
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          buttons={deleteButtons}
        />
      </div>

    </Modal>
  );
};

export default ClientGroup;